import React from 'react'
import styled from 'styled-components'
import Logic from './logic'
import axios from 'axios'
import uniqBy from 'lodash/uniqBy'

import ArrowIcon from './images/ic-arrow.svg'

import Form from 'containers/Form'
import Label from 'components/Label'
import Section from 'components/Section'
import ButtonRadio from 'components/ButtonRadio'
import Loading from 'components/Loading'
import Select from 'components/Select'
import UseType from 'components/UseType'
import Tip from 'components/Tip'

import VirtualizedSelect from 'react-virtualized-select'

import 'react-select/dist/react-select.css'
import 'react-virtualized/styles.css'
import 'react-virtualized-select/styles.css'

import { pickOrNot } from 'utils'
import { Messages } from 'validations'
import { GOOGLE_KEY } from 'config'

const GEO_LOCATION_OPTIONS = {
  maximumAge: 0,
}

/* eslint-disable camelcase */
@Logic
export default class CompanyProfile extends Form {
  nextText = `PRÓXIMO passo`
  useFactors = []

  componentDidMount() {
    const { currentLocalization } = this.props

    if (!currentLocalization) {
      navigator.geolocation.getCurrentPosition(
        this.geoSucess,
        this.geoError,
        GEO_LOCATION_OPTIONS
      )
    }

    for (let i = 0; i < 100; i = i + 5) {
      this.useFactors.push({
        label: i + '%',
        value: i / 100,
      })
    }
  }

  componentDidUpdate(lastProps) {
    const { data } = this.props
    const { caes } = data
    const { setValues } = this.actions

    if (!(caes && !lastProps.data.caes)) return

    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    // eslint-disable-next-line radix
    const newCae = parseInt(urlParams.get('cae'))

    if (!newCae) return

    // eslint-disable-next-line radix
    const caeObject = caes.find((cae) => parseInt(cae.label) === newCae)

    if (!caeObject) return

    setValues({ cae: caeObject.value })

    this.sendHeight()
    window.addEventListener('resize', this.sendHeight)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sendHeight)
  }

  sendHeight = () => {
    const height = document.body.scrollHeight
    window.parent.postMessage({ type: 'setHeight', height }, '*')
  }

  geoError = (error) => true

  geoSucess = (position) => {
    const { setCurrentLocation } = this.actions
    let lat
    let long

    lat = position.coords && position.coords.latitude
    long = position.coords && position.coords.longitude

    const GOOGLE_GEO_API = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&sensor=true&key=${GOOGLE_KEY}`

    try {
      const request = axios.get(GOOGLE_GEO_API)

      request.then((result) => {
        if (
          result.data.error_message ||
          result.data.status === 'OVER_QUERY_LIMIT' ||
          result.data.status === 'ZERO_RESULTS'
        ) {
          return false
        }

        let newArr = []
        result.data.results.forEach((component) => {
          newArr = [...newArr, ...component.address_components]
        })
        newArr = uniqBy(newArr, 'long_name')

        setCurrentLocation(newArr)
      })
    } catch (error) {}
  }

  /**
   * Next Button actions
   */
  next = () => {
    const { valid, invalid } = this.isFormValid()
    const { setInvalid, setFinished } = this.actions
    const { router } = this.props

    if (valid) {
      setFinished({ profileFinished: true })
      router.push('/faturacao')
      window.parent.postMessage({ type: 'scrollToTop' }, '*')
    } else {
      setFinished({ profileFinished: false })
      setInvalid(invalid)

      // Move to the places
      let locationInvalid = pickOrNot(invalid, ['district', 'municipality'])
      if (locationInvalid) {
        let location = document.getElementById('location')
        if (location) {
          location.scrollIntoView({ behavior: 'smooth' })
        }

        return false
      }

      let caesInvalid = pickOrNot(invalid, ['cae'])
      if (caesInvalid) {
        let caes = document.getElementById('caes')
        if (caes) {
          caes.scrollIntoView({ behavior: 'smooth' })
        }
      }

      let workingHoursInvalid = pickOrNot(invalid, ['work_hours'])
      if (workingHoursInvalid) {
        let work_hours = document.getElementById('work_hours')
        if (work_hours) {
          work_hours.scrollIntoView({ behavior: 'smooth' })
        }
      }
    }
  }

  /**
   * Renders invalid messags
   */
  renderInvalidMessage = (invalid, field, name) => {
    if (invalid) {
      if (invalid[field]) {
        const Message = Messages[invalid[field]]
        if (Message) {
          return <Error>{Message(name)}</Error>
        }
      }
    }
    return null
  }

  render() {
    const {
      districts,
      cities,
      loading,
      invalid,
      translations,
      iframed,
    } = this.props
    const { setValues, fetchCities } = this.actions

    const { caes, offerTypes, enterpriseProfiles } = this.props.data

    const {
      CAE,
      ENTERPRISE_SIMULATION_TARGET,
      ENTERPRISE_LOCATION,
      WORKING_HOURS,
    } = translations || {}

    const {
      offerType,
      cae,
      municipality,
      district,
      enterprise_profile,
    } = this.props.values

    const citiesDisabled = !district || !cities

    let locationInvalid = pickOrNot(invalid, ['district', 'municipality'])
    let caeInvalid = pickOrNot(invalid, ['cae'])

    if (loading) {
      return <Loading />
    }
    // All sections of this page
    const SimulateQuestion = (
      <Section
        title={`Simular`}
        subtitle={`O que pretende simular`}
        key={`simulate`}
        compact={iframed}>
        {ENTERPRISE_SIMULATION_TARGET && (
          <Tip data-slot='tip' text={ENTERPRISE_SIMULATION_TARGET} />
        )}
        <ButtonContainer>
          {offerTypes &&
            offerTypes.map(({ icon, text, value }, index) => (
              <ButtonRadio
                key={`ot-${index}`}
                onClick={() => setValues({ offerType: value })}
                icon={icon}
                name={text}
                selected={offerType === value}
              />
            ))}
        </ButtonContainer>
      </Section>
    )

    const localizationQuestion = (
      <Section
        title={`Localização`}
        subtitle={`Selecione o distrito e concelho`}
        className={locationInvalid && `invalid`}
        id='location'
        key={`location`}
        compact={iframed}>
        {ENTERPRISE_LOCATION && (
          <Tip data-slot='tip' text={ENTERPRISE_LOCATION} />
        )}
        {districts && (
          <WrapperLocation>
            <WrapperSelect>
              <LocationLabel fontSize='12px'>DISTRITO</LocationLabel>
              <StyledSelect
                margin
                placeholder={'Distrito'}
                items={districts}
                onChange={({ value }) => {
                  setValues({ district: value, municipality: undefined })
                  fetchCities(value)
                }}
                selected={district}
                arrowIcon={ArrowIcon}
              />
              {this.renderInvalidMessage(
                locationInvalid,
                'district',
                'Distrito'
              )}
            </WrapperSelect>
            <WrapperSelect>
              <LocationLabel fontSize='12px'>CONCELHO</LocationLabel>
              <StyledSelect
                disabled={citiesDisabled}
                placeholder={'Concelho'}
                items={cities}
                onChange={({ value }) => setValues({ municipality: value })}
                selected={municipality}
                arrowIcon={ArrowIcon}
              />
              {this.renderInvalidMessage(
                locationInvalid,
                'municipality',
                'Concelho'
              )}
            </WrapperSelect>
          </WrapperLocation>
        )}
      </Section>
    )

    const caeQuestion = (
      <Section
        title={`CAE`}
        subtitle={`Selecione o código de actividade empresarial da sua empresa`}
        className={caeInvalid && `invalid`}
        id='cae'
        key={`cae`}
        compact={iframed}>
        {CAE && <Tip data-slot='tip' text={CAE} />}
        {caes && (
          <WrapperLocation>
            <WrapperSelectCAE>
              <LocationLabel fontSize='12px'>CAE</LocationLabel>
              <StyledSelectCae
                options={caes}
                onChange={(ele) => {
                  if (ele != null) {
                    setValues({ cae: ele.value })
                  } else {
                    setValues({ cae: null })
                  }
                }}
                placeholder={`CAE`}
                arrowRenderer={arrowRenderer}
                value={cae}
              />
              {this.renderInvalidMessage(caeInvalid, 'cae', 'CAE')}
            </WrapperSelectCAE>
          </WrapperLocation>
        )}
      </Section>
    )

    const enterpriseProfile = (
      <Section
        title={`Período de Funcionamento`}
        subtitle={`Selecione o perfil mais adequado ao horário de funcionamento da sua empresa`}
        key={`enterpriseProfile`}
        compact={iframed}>
        {WORKING_HOURS && <Tip data-slot='tip' text={WORKING_HOURS} />}
        {enterpriseProfiles && (
          <UseType
            items={enterpriseProfiles}
            value={enterprise_profile}
            name='enterprise_profile'
            itemSize={'270px'}
            onSelectionChange={({ value }) =>
              setValues({ enterprise_profile: value })
            }
          />
        )}
      </Section>
    )

    return (
      <Wrapper>
        {this.renderNavbar()}

        {/** Renders in Simulador Enterprise Order **/}
        {[
          SimulateQuestion,
          localizationQuestion,
          caeQuestion,
          enterpriseProfile,
        ]}

        {this.renderButtons(loading)}
      </Wrapper>
    )
  }
}

const SelectIcon = styled.span`
  background-image: url(${({ arrowIcon }) => arrowIcon});
  width: 12px;
  height: 12px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  display: block;
`

const arrowRenderer = () => {
  return <SelectIcon arrowIcon={ArrowIcon} />
}

const Wrapper = styled.div``

const WrapperLocation = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;

    > div:first-child {
      margin-bottom: 30px;
    }
  }
`

const WrapperSelect = styled.div`
  width: 270px;
  margin: 10px;
`

const WrapperSelectCAE = styled.div`
  width: 420px;
  position: relative;

  @media screen and (max-width: 768px) {
    width: 320px;
  }
`

const StyledSelectCae = styled(VirtualizedSelect)`
  width: 420px;

  @media screen and (max-width: 768px) {
    width: 320px;
  }
  .is-focused {
    .Select-control {
      border: 1px solid #bababa;
    }
  }
  > .Select-control {
    box-shadow: none !important;
    border: 1px solid #bababa;
    border-color: #bababa !important;
    border-radius: 0px;
    height: 50px;
    font-size: 14px;
    font-family: 'Nunito', 'Helvetica Neue', sans-serif;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);

    .Select-placeholder {
      line-height: 48px;
    }
    .Select-input {
      height: 48px;
      line-height: 48px;
    }
    .Select-value {
      line-height: 48px !important;
      outline: none;
      text-align: left;
      padding-left: 16px;
      &:focus {
        outline: none;
      }
      &:blur {
        outline: none;
      }
    }
  }
  .VirtualizedSelectOption {
    overflow: hidden;
    text-align: left;
    white-space: nowrap;
    vertical-align: top;
    font-size: 14px;
    font-family: 'Nunito', 'Helvetica Neue', sans-serif;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
    padding: 16px 15px 15px 16px;

    &:hover {
      background-color: #efefef;
    }
  }
  .VirtualizedSelectFocusedOption {
    background-color: #efefef;
  }
  .VirtualizedSelectSelectedOption {
    background-color: #efefef;

    &:hover {
      background-color: #efefef;
    }
  }
`

const StyledSelect = styled(Select)`
  width: 100%;
  max-width: initial;

  > div {
    border: 1px solid #bababa;
    color: #3e3e3e;
    > div {
      text-align: left;
    }
  }
  ${({ margin }) => margin && `margin-right: 30px;`}
`

const LocationLabel = styled(Label)`
  text-align: left;
  padding-bottom: 5px;
`

const ButtonContainer = styled.div`
  display: flex;

  justify-content: center;
  margin-top: 32px;
`

const Error = styled.span`
  display: inline-block;
  font-size: 12px;
  color: indianred;
  margin: 10px auto;
  text-align: left;
`



// WEBPACK FOOTER //
// ./src/containers/CompanyProfile/index.js